<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <div :class="styles" v-html="text"></div>
</template>

<script lang="ts" setup>
import { computed, toRefs } from "vue";

const props = withDefaults(
  defineProps<{
    text: string;
    classes?: string;
    isUmbraco?: boolean;
    theme: "dark" | "light";
    isManchet?: boolean;
  }>(),
  { isManchet: false }
);

const { text, classes, isUmbraco, theme, isManchet } = toRefs(props);

const styles = computed(() => {
  const paragraphStyles = isManchet.value
    ? "[&_p]:manchetText"
    : "[&_p]:paragraph [&_p]:lg:mb-5";
  const color =
    isUmbraco.value && theme.value === "dark"
      ? "text-white [&_*]:text-white"
      : isUmbraco.value && theme.value === "light"
      ? "text-aubergine [&_*]:text-aubergine"
      : "text-typography [&_*]:text-typography";
  return `themeTransition
  ${color}
  ${paragraphStyles}
  [&_h1]:h1 [&_h1]:mb-3
  [&_h2]:h2 [&_h2]:mb-3
  [&_h3]:h3 [&_h3]:mb-3
  [&_h4]:h4 [&_h4]:mb-3
  [&_ul]:list-disc [&_ul]:ml-[1.5em] [&_ul]:lg:ml-[2em] [&_ul]:mb-10 [&_ul]:lg:mb-[60px]
  [&_ol]:ol
  [&_li]:li 
  [&_img]:mt-5 [&_img]:mb-3 [&_img]:lg:mt-10 [&_img]:lg:mb-5
  [&_span]:span
  
  ${classes?.value}
  [&_a.arrowlink]:no-underline [&_a.arrowlink:hover]:underline [&_a.arrowlink]:font-bold
  [&_table]:text-aubergine [&_table]:text-sm [&_table]:lg:text-sm
    [&_tbody]:text-wrap
    [&_thead]:bg-[#B6949A]
    [&_th]:border [&_th]:border-aubergine [&_th]:text-left [&_th]:py-5 [&_th]:px-2 [&_th]:bg-[#B6949A]
    [&_td]:td [&_td]:py-5 [&_td]:px-2 [&_td]:min-w-[120px] [&_td]:border [&_td]:border-aubergine [&_td]:test
`;
});
</script>
